import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Offcanvas, ToastContainer, Toast } from 'react-bootstrap';
import QuestionList from './components/QuestionList';
import FilterSort from './components/FilterSort';
import { Question } from './components/DataDefinitions';
import Button from 'components/base/Button';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
//import qs from 'qs'; // You can install this with `npm install qs`
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import QuestionComposer from './components/QuestionComposer';
import QuestionSearch from './components/QuestionSearch';

const QAForum: React.FC = () => {


    const { t } = useTranslation();
    // State to control Toast messages
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const [loading, setLoading] = useState(false);

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Blogs.page_title'),
            url: '/community'
        },

        {
            label: t('QAForum.page_title'),
            active: true
        }
    ];
    const auth = useAuth();


    const [questions, setQuestions] = useState<Question[]>([]);
    const [tags, setTags] = useState<string[]>([]);


    const fetchData = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                query: '',
                limit: '10',
                offset: '0'
            });

            const response = await apiClient.get(
                `/v1/forum/search?${params}`,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            setQuestions(response.data['questions']);
            setTags(response.data['tags'])
        } catch (error) {
            console.error('Error fetching data:', error);
            const message = handleAPIError(error);
            if (message) {
                setToastMessage(message);
                setShowToast(true);
                return
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        //fetchData();
    }, []);

    const handleNewQuestionSubmit = async () => {
        setShow(false);
        fetchData();
    };



    if (loading) {
        return <div>Loading...</div>;
    }

    const handleClick = () => {
        setShow(true);
    };

    const handleSearchResults = (results: Question[], tags: string[]) => {
        setQuestions(results);

        if (tags.length > 0)
            setTags(tags);
    };

    const onErrorSearch = (error: string) => {
        setToastMessage(error);
        setShowToast(true);
    }


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} backdrop="static" placement="end" style={{ 'width': '50%' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className='fs-5' >{t('QAForum.ask_question')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <QuestionComposer onSubmit={handleNewQuestionSubmit} />
                </Offcanvas.Body>
            </Offcanvas>

            <ToastContainer className="p-3" position='top-center'>
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
                    <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>

            <PageBreadcrumb items={breadcrumbItems} />

            <div className="mt-4">
                <Card className='border border-light rounded-5 mb-4' >
                    <Card.Body>

                        <Row className="mb-4">
                            <Col>
                                <h1></h1>
                            </Col>
                            <Col xs="auto">
                                <Button variant="primary" size="lg" onClick={handleClick} >
                                    {t('QAForum.ask_question')}
                                </Button>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <div className="d-flex gap-2">
                                <QuestionSearch onSearch={handleSearchResults} tags={tags} onError={onErrorSearch} />
                            </div>
                        </Row>
                        <Row>
                            <QuestionList initialQuestions={questions} />
                        </Row>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};


export default QAForum;